<template>
  <div class="calendar">
    <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>生日視頻</p>
    </div>
    <el-form>

      <el-form-item label="開始時間:" >
        <el-date-picker format='yyyy-MM-dd HH:mm' v-model="startTime" type="datetime" placeholder="選擇時間"></el-date-picker>
      </el-form-item>

      <el-form-item label="結束時間:" >
        <el-date-picker format='yyyy-MM-dd HH:mm' v-model="endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
      </el-form-item>
      
      <el-form-item label="上傳影片:">
        <video width="80%" v-if="VideoUrl.length==1" class="avatar" :src="VideoUrl[0].url" controls="controls">您的浏览器不支持视频播放</video>
        <span @click="handleVideoRemove()" v-if="VideoUrl.length == 1">刪除</span>
        <el-upload
        :action='this.$GLOBAL.videopostUrl'
        :with-credentials= 'true'
        :headers="{'Authorization': this.$cookie.get('auth')}"
        :data="uploadData"
        :on-success='successVideo'
        :on-error ='errorVideo'
        :on-exceed="handleVideoExceed"
        :on-remove="handleVideoRemove"
        :on-progress="uploadVideoProcess"
        :file-list="VideoUrl"
        :show-file-list="false"
        :before-upload="beforeVideoUpload"
        :limit= 1
        accept= ".mp4"
        :multiple='false'
        name= 'multipartFile'
        list-type="picture-card">
        <el-button v-if="!videoFlag" size="small" type="primary">選擇視頻</el-button>
        <div slot="tip" class="el-upload__tip">支持mp4格式</div>
        <el-progress v-if="videoFlag" type="circle" :percentage="videoUploadPercent" style="margin-top:10px;"></el-progress>
        <!-- accept=".mp4,.3gp,.3gpp,.rm,.rmvb,.avi,.wmv,.mov" -->
        </el-upload>
      </el-form-item>

      <div class="editor-wrap">
        <p class="editor-title">生日文案:</p>
        <Editor style="color:#fff;" @listenContent='getContent' :content='content' :colorFlag='true' :newsFlag='true'></Editor>
      </div>
    </el-form>

    <div class="bottomBtn">
      <div class="btn" @click="submitContent()">發佈</div>
    </div>

  </div>
</template>

<script>
import Editor from '@/components/editor';
import NavBar from '@/components/navBar';
export default {
  props: ['type','id'],
  data () {
    return {
      limit: 1,
      VideoUrl: [],
      videoUploadPercent: '',
      startTime: '',
      endTime: '',
      uploadData: { //上传图片的附加参数
        flag: 'xw'
      },
    }
  },
  created(){
  },
  methods:{
    // 编辑行事历的查询详情
    initBirthVideo(){
      let _this = this;
      _this.$get('/calendar/activity/' + _this.id, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {

          } else {
            _this.$Mint.Toast(res.message);
          }
        });
    },
    // 上传图片之前的回调函数
    beforeVideoUpload(file) {
      let _this = this;
      // const isVideo = file.type === 'video/mp4' || 'video/3gp' || 'video/3gpp' || 'video/rm' || 'video/rmvb' || 'video/avi' || 'video/wmv' || 'video/mov';
      const isVideo = file.type === 'video/mp4';
      const isLt200M = file.size / 1024 / 1024 < 2048;
      if (!isVideo) {
        _this.$Mint.Toast('上傳視頻格式不正確!');
        return false;
      };
      if (!isLt200M) {
        _this.$Mint.Toast('上傳視頻大小不能超過2GB!');
        return false;
      };
    },
    // 移除图片的回调函数
    handleVideoRemove(file) {
      let _this = this;
      _this.VideoUrl =[]
      _this.videoFlag = false;
      _this.$Mint.Toast({message: '刪除成功'});
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
      return false;
    },
    // 上传video的进度条
    uploadVideoProcess(event, file, fileList){
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0);
    },
    // 上传video成功的回调函数
    successVideo(res, file) {
      let _this = this;
      _this.VideoUrl.push({name:'video.mp4', url: res.msg})      
      document.getElementsByClassName('el-upload')[0].style.display = 'none';
    },
    // 上传video失败的回调函数
    errorVideo () {
      this.$Mint.Toast({message: '上傳失敗！請重新登錄'});
      setTimeout(function () {
        this.$router.push('/login')         
      }, 500)
    },
    // 上传video超出限制数量的回调函数
    handleVideoExceed() {
      this.$Mint.Toast({message: '最多上傳一個視頻'});
      return false;
    },
    // 提交修改内容方法
    submitContent(){
      let _this = this;
      if (_this.startTime === '' || _this.startTime === null) {
        _this.$Mint.Toast('開始時間不能為空');
        return false;
      }
      if (_this.startTime === '' || _this.startTime === null) {
        _this.$Mint.Toast('結束時間不能為空');
        return false;
      }
      if (_this.VideoUrl.length===0) {
        
      }
      // 新增提交
      if(_this.type === 'add') {
        let param = {
          calendarAddress: _this.calendar.activityPlace,
          calendarImg: _this.fileList[0].url,
          calendarName: _this.calendar.activityName,
          calendarTime: _this.calendar.activityDate,
          type: Number(_this.calendar.type),
          id: ''
        };
        _this.$post('/calendar/activity',param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            if (res.code==='00000') {
              _this.$message({
                center: true,
                message: '發佈成功',
                type: 'success',
                duration: 500
              });
              setTimeout(function () {
                _this.$router.push('/calendarList');
              },500);
              // _this.$router.push('/calendarList?propFlag=' + true);
            } else {
              // _this.$Mint.Toast(res.message);
              _this.$message({
                center: true,
                message: res.message,
                type: 'error'
              });
            }
          });
      } else if (_this.type === 'edit') {
        // 编辑提交
        let editParam = {
          calendarAddress: _this.calendar.activityPlace,
          calendarImg: _this.fileList[0].url,
          calendarName: _this.calendar.activityName,
          calendarTime: _this.calendar.activityDate,
          type: Number(_this.calendar.type),
          id: _this.id
        };
        _this.$put('/calendar/activity', editParam, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            if (res.code==='00000') {
              _this.$message({
                center: true,
                message: '發佈成功',
                type: 'success',
                duration: 500
              });
              setTimeout(function () {
                _this.$router.push('/calendarList');
              },500);
              // _this.$router.push('/calendarList?propFlag=' + true);
            } else {
              // _this.$Mint.Toast(res.message);
              _this.$message({
                center: true,
                message: res.message,
                type: 'error'
              });
            }
          });
      };
    },
  },
  components: {
    NavBar,
    Editor
  }
};
</script>



// WEBPACK FOOTER //
// src/components/birthdayVideo.vue